import { useQuery } from '@tanstack/react-query';
import { getUserMe } from '../api/auth';

const useUserMe = () => {
  return useQuery({
    queryKey: ['userMe'],
    queryFn: getUserMe,
    staleTime: 1000 * 60 * 5,
    cacheTime: 1000 * 60 * 10,
    refetchOnWindowFocus: false,
  });
};

export default useUserMe;